export { Tabs } from "./Tabs";
export type { TabSections } from "./Tabs";
